<template>
  <CCard>
    <CCardBody>
      <h5 class="text-primary">Predictive Analysis - Forecasting Applications</h5>
      <div>
        <BasicLine
          :data="forecastingChartData"
          :height="300"
          :showLegend="false"
        />
      </div>
    </CCardBody>
  </CCard>
</template>
<script>
import candidate from "@/containers/KSADashboard/candidate.json";
import BasicLine from "@/components/reusable/Charts/BasicLine.vue";
export default {
  name: "ForecastingChart",
  components: {
    BasicLine,
  },
  data() {
    return {
      forecastingChartData: [],
    };
  },
  mounted() {
    this.getForecastingChartData();
  },
  methods: {
    getForecastingChartData() {
      const groupBy = (arr, key) =>
        arr.reduce((acc, obj) => {
          acc[obj[key]] = acc[obj[key]] || [];
          acc[obj[key]].push(obj);
          return acc;
        }, {});

      const mostFrequent = (arr, key) => {
        const freq = arr.reduce((acc, cur) => {
          acc[cur[key]] = (acc[cur[key]] || 0) + 1;
          return acc;
        }, {});
        const sorted = Object.entries(freq).sort((a, b) => b[1] - a[1]);
        return sorted[0][0];
      };

      // --- Step 1: Monthly application counts ---
      const monthGroups = groupBy(candidate, "Application Month");
      const monthCounts = Object.entries(monthGroups).map(
        ([month, records]) => ({
          month,
          count: records.length,
          date: new Date(records[0].application_date),
        })
      );
      monthCounts.sort((a, b) => a.date - b.date);

      // --- Step 2: Calculate average trend ---
      let trend = 0;
      for (let i = 1; i < monthCounts.length; i++) {
        trend += monthCounts[i].count - monthCounts[i - 1].count;
      }
      trend = trend / (monthCounts.length - 1);

      // --- Step 3: Frequency-based predictions ---
      const topCategory = mostFrequent(candidate, "Category");
      const topProgram = mostFrequent(candidate, "Program");
      const topNationality = mostFrequent(candidate, "Applicant Nationality");

      // --- Step 4: Predict next 6 months ---
      const lastDate = monthCounts[monthCounts.length - 1].date;
      let lastCount = monthCounts[monthCounts.length - 1].count;

      const predictions = [];
      for (let i = 1; i <= 12; i++) {
        const nextDate = new Date(lastDate);
        nextDate.setMonth(lastDate.getMonth() + i);
        const nextMonthStr = nextDate.toLocaleString("default", {
          month: "long",
          year: "numeric",
        });

        lastCount = Math.max(0, Math.round(lastCount + trend)); // linear projection

        predictions.push({
          month: nextMonthStr,
          expected_applications: lastCount,
          likely_category: topCategory,
          likely_program: topProgram,
          dominant_nationality: topNationality,
        });
      }
      const data = predictions.map((item) => ({
        name: item.month,
        value: item.expected_applications,
      }));
      this.forecastingChartData = [
        {
          name: "Predicted Application",
          backgroundColor: "#9AD0F5",
          borderColor: "#36A2EB",
          values: data,
          type: "line",
          tension: 0.3,
          fill: false,
        },
      ];
    },
  },
};
</script>
<style lang="scss" scoped></style>
